import { AbstractGlobalProvider } from './provider.js';
/**
 * Global {@link SaveGameProvider}.
 *
 * Allows registering multiple services to automatically detect
 * available ones and fall-back to others.
 */
class SaveGame extends AbstractGlobalProvider {
    name = 'uber-savegame-provider';
    load(out) {
        for (const p of this.providers) {
            let v = p.load(out);
            if (v == null)
                continue;
            return v;
        }
        return null;
    }
    save(o) {
        for (const p of this.providers)
            p.save(o);
    }
}
export const saveGame = new SaveGame();
